import React from 'react';
import '../styles/components/LoadingSpinner.css';

/**
 * LoadingSpinner - 共通ローディングコンポーネント
 *
 * @param {string} message - ローディングメッセージ（デフォルト: "読み込み中..."）
 * @param {string} size - サイズ（small, medium, large）
 * @param {boolean} fullPage - フルページ表示にするか
 */
const LoadingSpinner = ({
  message = '読み込み中...',
  size = 'medium',
  fullPage = false
}) => {
  const containerClass = fullPage
    ? 'loading-spinner__fullpage'
    : 'loading-spinner__container';

  return (
    <div className={containerClass}>
      <div className={`loading-spinner loading-spinner--${size}`}>
        <div className="loading-spinner__circle"></div>
        <div className="loading-spinner__circle"></div>
        <div className="loading-spinner__circle"></div>
      </div>
      {message && <p className="loading-spinner__message">{message}</p>}
    </div>
  );
};

export default LoadingSpinner;
